import AsyncStorage from '@react-native-async-storage/async-storage';
import { executeReprintFromQZ } from '../../../qzservice';
import axios from '../../config/axios';

export const storeLastPrintJob = async (socketData, settings, printer) => {
  try {
    let printJobData;
    if (socketData.data) {
      printJobData = {
        url: socketData.data.url,
        printType: socketData.data.print_type,
        dimensions: socketData.data.dimensions,
        settings: settings,
        printer: printer,
        orderNumber: socketData.data.increment_id,
        timestamp: new Date().toISOString()
      };
    } else {
      printJobData = {
        url: socketData.url || null,
        printType: socketData.printType,
        dimensions: socketData.dimensions || null,
        settings: settings,
        printer: printer,
        orderNumber: socketData.orderNumber,
        timestamp: new Date().toISOString()
      };
    }

    await AsyncStorage.setItem('lastPrintJob', JSON.stringify(printJobData));
    return printJobData;
  } catch (error) {
    console.error('Error storing last print job:', error);
    return null;
  }
};

export const getLastPrintJob = async () => {
  try {
    const storedData = await AsyncStorage.getItem('lastPrintJob');
    if (storedData) {
      return JSON.parse(storedData);
    }
    return null;
  } catch (error) {
    console.error('Error getting last print job:', error);
    return null;
  }
};

export const clearLastPrintJob = async () => {
  try {
    await AsyncStorage.removeItem('lastPrintJob');
    console.log('Cleared last print job data');
  } catch (error) {
    console.error('Error clearing last print job:', error);
  }
};

export const executeReprint = async (alertBox = null) => {
  try {
    const lastPrintJob = await getLastPrintJob();

    if (!lastPrintJob) {
      console.error('No last print job data found');
      return false;
    }

    if (!lastPrintJob.orderNumber) {
      return false;
    }
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    const response = await axios({
      method: 'post',
      url: `${url}/orders/generate_failed_labels`,
      headers: { Authorization: `Bearer ${access_token}` },
      data: {
        order_number: lastPrintJob.orderNumber,
        print_type: lastPrintJob.printType
      }
    });

    if (response.data.status && response.data.url) {
      const updatedPrintJob = {
        ...lastPrintJob,
        url: response.data.url
      };
      const success = await executeReprintFromQZ(updatedPrintJob, alertBox);
      return success;
    } else {
      console.error('API response missing status or url:', response.data);
      return false;
    }
  } catch (error) {
    console.error('Error executing reprint:', error);
    return false;
  }
};

export const isReprintEnabled = (scanPackSettings) => {
  return scanPackSettings?.enable_reprint_option === true;
};

export const getReprintDuration = (scanPackSettings) => {
  const duration = scanPackSettings?.reprint_option_duration || 20;
  return duration * 1000;
};

export const getPrintTypeDisplayName = (printType) => {
  switch (printType) {
    case 'packing_slip':
      return 'packing slip';
    case 'order_barcode':
      return 'order barcode';
    default:
      return 'label';
  }
};

export const getReprintPrintType = (scanPackSettings, generalSettings) => {
  if (scanPackSettings?.post_scanning_option === 'Barcode') return 'order_barcode';
  if (scanPackSettings?.post_scanning_option === 'PackingSlip') return 'packing_slip';
  if (
    generalSettings?.multi_box_shipments &&
    generalSettings?.per_box_packing_slips === 'when_order_is_complete'
  ) {
    return 'packing_slip';
  }
  return null;
};

export const queueReprintPrompt = async (orderNumber, printType, scanPackSettings, generalSettings) => {
  if (!scanPackSettings?.enable_reprint_option) return { ok: true, queued: false };

  const directPrintingEnabled =
    printType === 'order_barcode'
      ? generalSettings?.print_post_scanning_barcodes
      : generalSettings?.print_packing_slips;
  if (!directPrintingEnabled) return { ok: true, queued: false };

  try {
    let printerKey;
    if (printType === 'order_barcode') {
      printerKey = 'user_selected_printer_order_barcode_label';
    } else {
      const packingSlipSize = await AsyncStorage.getItem('Packing_slip_size');
      printerKey = `user_selected_printer_packing_slip_${packingSlipSize}`;
    }

    const selectedPrinterStr = await AsyncStorage.getItem(printerKey);
    if (!selectedPrinterStr) return { ok: true, queued: false };

    await storeLastPrintJob(
      { orderNumber, printType, url: null },
      scanPackSettings,
      JSON.parse(selectedPrinterStr)
    );
    await AsyncStorage.setItem(
      'reprint_trigger',
      JSON.stringify({ orderNumber, printType, timestamp: new Date().getTime() })
    );
    return { ok: true, queued: true };
  } catch (error) {
    return { ok: false, error };
  }
};
